const size = {
  maxWidth: 1920,
}

export default size
